/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCompetenceRequestViewModel } from "../types/CreateCompetenceRequestViewModel.ts";

export const createCompetenceRequestViewModelSchema = z.object({
  name: z.string().describe("Nome da competência.").nullish(),
  description: z
    .string()
    .describe("Descrição da competência. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe("Idioma (cultura) da tradução inicial.")
    .nullish(),
}) as unknown as ToZod<CreateCompetenceRequestViewModel>;
